// extracted by mini-css-extract-plugin
export var orderSummary = "_u6-0";
export var showMoreLessButton = "_u6-1";